/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { affordabilityCalculatorPostRequestSchema } from './affordabilityCalculatorPostRequestSchema.ts';
import { affordabilityCalculatorPostResponseSchema } from './affordabilityCalculatorPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postAffordabilityCalculator200Schema = z.lazy(() => affordabilityCalculatorPostResponseSchema);

/**
 * @description 505 response
 */
export const postAffordabilityCalculator505Schema = z.any();

export const postAffordabilityCalculatorMutationRequestSchema = z.lazy(() => affordabilityCalculatorPostRequestSchema);

export const postAffordabilityCalculatorMutationResponseSchema = z.lazy(() => postAffordabilityCalculator200Schema);
